import { TokenRenewMode } from '@axa-fr/react-oidc';
import { clientConfig } from './configService';

let applicationMame = clientConfig?.APPLICATION_NAME || '';
let clientId = import.meta.env.REACT_APP_IDP_CLIENT_ID ? import.meta.env.REACT_APP_IDP_CLIENT_ID : "";
let client_id = applicationMame + '-' + clientId;
let authority = import.meta.env.REACT_APP_IDP_AUTHORITY ? import.meta.env.REACT_APP_IDP_AUTHORITY : "";
let clientScope = import.meta.env.REACT_APP_IDP_CLIENT_SCOPE ? import.meta.env.REACT_APP_IDP_CLIENT_SCOPE : "openid profile sightline.el.api offline_access";

export const IDENTITY_CONFIG = {
    client_id: client_id,
    redirect_uri: window.location.origin + "/authentication/callback",
    silent_redirect_uri: window.location.origin + "/authentication/silent-callback",
    response_type: 'code',
    scope: clientScope, // offline_access scope allow your client to retrieve the refresh_token
    authority: authority,
    refresh_time_before_tokens_expiration_in_second: 10,
    // Disable the react-oidc v7 loading-timeout watchdog. This app supports anonymous
    // browsing, so the provider legitimately stays in its initial (no-token) state and
    // the default 30s watchdog would otherwise show a false "Loading timeout" error page.
    loading_timeout_ms: 0,
    loadUserInfo: true,
    service_worker_relative_url: "/OidcServiceWorker.js",
    service_worker_only: false,
    token_renew_mode: TokenRenewMode.access_token_invalid,
};
